// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__96uC6","sm":"Button_sm__pnQzd","md":"Button_md__ktIWF","lg":"Button_lg__s7W56","primary":"Button_primary__6_Dls","secondary":"Button_secondary__uuOdH","outline":"Button_outline__PQR9W","ghost":"Button_ghost__gZqlA"};
module.exports.__checksum = "a4f32086781a"
